import {
  CurrentPatientQuery,
  useCurrentPatientQuery,
} from "@components/Booking/graphql/__generated__/current-patient.type";

const getCurrentPatient = (data?: CurrentPatientQuery) =>
  data?.me?.__typename === "PatientUser" ? data.me.defaultPatient : null;

export default function useCurrentPatient() {
  const {data, loading} = useCurrentPatientQuery();
  return {patient: getCurrentPatient(data), loading};
}
